/**
 * INFINITY LIFE 2.0 — Date and Time Utilities (Brazilian Standard pt-BR)
 */

export const DIAS_SEMANA = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
export const DIAS_SEMANA_ABREV = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
export const MESES = ['', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
export const MESES_ABREV = ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

/**
 * Format YYYY-MM-DD to DD/MM/YYYY
 */
export function formatDateBR(dateString) {
  if (!dateString) return '';
  const parts = dateString.split('-');
  if (parts.length !== 3) return dateString;
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

/**
 * Format YYYY-MM-DD to "Segunda, 12 de Outubro"
 */
export function formatDateFullBR(dateString) {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  const diaSemana = DIAS_SEMANA[date.getDay()];
  const mes = MESES[month];
  return `${diaSemana}, ${day} de ${mes}`;
}

/**
 * Relative date description: "Hoje", "Amanhã", "Ontem", or formatted date
 */
export function getRelativeDateLabel(dateString) {
  if (!dateString) return 'Sem prazo';

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [y, m, d] = dateString.split('-').map(Number);
  const target = new Date(y, m - 1, d);
  target.setHours(0, 0, 0, 0);

  const diffTime = target - today;
  const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'Hoje';
  if (diffDays === 1) return 'Amanhã';
  if (diffDays === -1) return 'Ontem';
  if (diffDays < -1) return `Atrasado (${Math.abs(diffDays)}d)`;
  if (diffDays <= 7) return DIAS_SEMANA[target.getDay()];

  return formatDateBR(dateString);
}

/**
 * Format time HH:MM:SS to HH:mm
 */
export function formatTimeBR(timeString) {
  if (!timeString) return '';
  return timeString.substring(0, 5);
}

/**
 * Generate hours list for day timeline (06:00 to 22:00)
 */
export function getDayHours() {
  const hours = [];
  for (let i = 6; i <= 22; i++) {
    hours.push({
      hour: i,
      label: `${String(i).padStart(2, '0')}:00`,
    });
  }
  return hours;
}
